import WelcomePage from '@/pages/WelcomePage';
import HomeRedirect from '@/components/auth/HomeRedirect';

export const RootRoute = () => {
  let signedInBefore = false;
  try {
    signedInBefore = Boolean(localStorage.getItem('access_token'));
  } catch {
    signedInBefore = false;
  }

  return signedInBefore ? <HomeRedirect /> : <WelcomePage />;
};
